import React from 'react';

import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import theme from '../../../styles/theme';

const PREFIX = 'IconLabel';

const classes = {
  icon: `${PREFIX}-icon`,
};

const Root = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  borderRadius: '10px',
  padding: theme.spacing(1.25),
  color: theme.palette.common.white,
  width: 'fit-content',
  display: 'flex',

  [`& .${classes.icon}`]: {
    width: '24px',
    height: '24px',
  },
}));

const IconLabel = (props) => {
  const { icon, className, style } = props;

  const styledIcon = React.cloneElement(icon, { className: className || classes.icon });
  return <Root sx={style}>{styledIcon}</Root>;
};

IconLabel.propTypes = {
  icon: PropTypes.element.isRequired,
};

export default IconLabel;
